export function travelerRequestError(cause: unknown, fallback: string): string {
  if (cause instanceof SyntaxError)
    return 'La réponse du serveur n’a pas pu être lue. Réessayez.';
  if (
    cause instanceof TypeError &&
    /^(Failed to fetch|Load failed|Network request failed|NetworkError.*)/i.test(cause.message)
  )
    return 'Connexion au serveur impossible. Vérifiez votre connexion puis réessayez.';
  if (
    !(cause instanceof Error) ||
    cause instanceof TypeError ||
    !cause.message.trim() ||
    /^[A-Z][A-Z0-9_]+$/.test(cause.message)
  )
    return fallback;
  return cause.message;
}
